import React, { useState, useTransition, Suspense } from 'react';

import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import IntroComponent from './components/IntroComponent';
import QuestionComponent from './components/QuestionComponent';
import ResultsComponent from './components/ResultsComponent';
import ErrorBoundary from './components/ErrorBoundary';

import './App.css';
import { questions } from './data';

const theme = createTheme({
  typography: {
    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
    h1: {
      fontWeight: 'bold',
    },
    h2: {
      fontWeight: 'bold',
    },
    h3: {
      fontWeight: 'bold',
    },
    h4: {
      fontWeight: 'thin',
    },
    h5: {
      fontWeight: '200',
    },
    h6: {
      fontWeight: '400',
    },
  },
  palette: {
    primary: {
      main: 'rgb(231, 35, 5)',
      light: 'rgb(252, 83, 70)',
      contrastText: '#fff',
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <Suspense fallback={<BigSpinner />}>
          <RouterComponent />
        </Suspense>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

function RouterComponent() {
  const [pageData, setPageData] = useState({ path: '/', state: null });
  const [, startTransition] = useTransition();
  //  const [isPending, startTransition] = useTransition();

  function navigate(url, state = null) {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    startTransition(() => {
      setPageData({ path: url, state });
    });
  }

  let content;
  if (pageData.path === '/') {
    content = <IntroComponent navigate={navigate} />;
  } else if (pageData.path.startsWith('/questions/')) {
    const questionId = parseInt(pageData.path.split('/questions/')[1], 10);
    const questionData = questions.find(q => q.id === questionId);
    if (questionData) {
      content = <QuestionComponent navigate={navigate} questionData={questionData} />;
    } else {
      content = <div>Question not found!</div>;
    }
  } else if (pageData.path.startsWith('/results/')) {
    const outcomeIds = pageData.path.split('/results/')[1].split('/');
    const primaryOutcomeId = parseInt(outcomeIds[0], 10);
    const inspirationOutcomeId = parseInt(outcomeIds[1], 10);
    content = <ResultsComponent primaryOutcomeId={primaryOutcomeId} inspirationOutcomeId={inspirationOutcomeId} navigate={navigate} state={pageData.state} />;
  }

  return content;
}

function BigSpinner() {
  return <Typography variant="h2">Loading...</Typography>;
}